/* src/app/system-utils/edit-data-grid/edit-data-grid.component.scss */
.configuration-fields {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: auto;
  padding: 6px;
}
.view-component-title {
  align-content: center;
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 8px 20px;
  background: rgba(0, 0, 0, 0.03);
}
.grid-face {
  display: flex;
  flex-direction: column;
  height: 100%;
}
form {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 10px;
}
.content {
  position: relative;
  padding-top: 15px;
  display: flex;
  flex-direction: column;
  font-size: 80%;
  height: 100%;
}
.more-options {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  padding-right: 10px;
  height: 100%;
  gap: 10px;
}
.more-options-color {
  padding-top: 4px;
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
  align-items: center;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 10px;
  height: 100%;
}
.customtextarea {
  height: 100%;
  resize: none;
}
.fields-grid {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding-top: 4px;
}
.tool-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: var(--tem-space-2);
  padding: var(--tem-space-2) var(--tem-space-3);
  background: var(--tem-surface-2);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
}
.panel-main {
  margin: 0px !important;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
/*# sourceMappingURL=edit-data-grid.component.css.map */
